import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export default function TermsOfServicePage() {
  return (
    <div data-testid="terms-of-service-page">
      <section className="py-20 md:py-28 bg-[#FDFBF7]">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.div {...fadeUp}>
            <div className="flex items-center gap-3 mb-6">
              <FileText className="text-[#A67A5B]" size={20} />
              <p className="font-sans text-xs tracking-[0.3em] uppercase text-[#A67A5B]">Legal</p>
            </div>
            <h1 className="font-serif text-4xl sm:text-5xl font-semibold text-[#2A2421] mb-4 leading-tight">
              Terms of Service
            </h1>
            <p className="font-sans text-sm text-[#7A736E] mb-12">Last updated: April 2026</p>

            <div className="space-y-10 font-sans text-[#2A2421]/80 leading-relaxed">
              <div>
                <h2 className="font-serif text-2xl font-semibold text-[#2A2421] mb-4">Welcome</h2>
                <p className="text-base">
                  By accessing and using the Led By Faith Studios website, you agree to the following terms and conditions. Please read them carefully. If you do not agree, please do not use this site.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl font-semibold text-[#2A2421] mb-4">Use of This Website</h2>
                <p className="text-base mb-3">This website is provided for informational and commercial purposes. You agree to:</p>
                <ul className="list-disc list-inside space-y-2 text-sm text-[#7A736E]">
                  <li>Use the site in a lawful and respectful manner</li>
                  <li>Not reproduce, distribute, or modify any content without written permission</li>
                  <li>Not attempt to interfere with the site's functionality or security</li>
                  <li>Provide accurate information when submitting forms or making inquiries</li>
                </ul>
              </div>

              <div>
                <h2 className="font-serif text-2xl font-semibold text-[#2A2421] mb-4">Intellectual Property</h2>
                <p className="text-base">
                  All content on this website &mdash; including text, images, book covers, logos, and design elements &mdash; is the property of Led By Faith Studios and/or Cypress Admin Studio. Unauthorized use of any content is prohibited without prior written consent.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl font-semibold text-[#2A2421] mb-4">Third-Party Links &amp; Purchases</h2>
                <p className="text-base">
                  This website contains links to third-party platforms including Amazon and Shopify. Purchases made through these platforms are subject to their respective terms, policies, and conditions. Led By Faith Studios is not responsible for transactions processed by third-party platforms.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl font-semibold text-[#2A2421] mb-4">Disclaimer</h2>
                <p className="text-base">
                  This website and its content are provided "as is" without warranties of any kind, express or implied. While we strive to keep all information accurate and up to date, we do not guarantee the completeness or reliability of any content.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl font-semibold text-[#2A2421] mb-4">Limitation of Liability</h2>
                <p className="text-base">
                  Led By Faith Studios shall not be held liable for any damages arising from the use of this website, including but not limited to direct, indirect, incidental, or consequential damages.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl font-semibold text-[#2A2421] mb-4">Changes to These Terms</h2>
                <p className="text-base">
                  We reserve the right to update these Terms of Service at any time. Changes will be posted on this page with an updated date. Continued use of the website constitutes acceptance of the updated terms.
                </p>
              </div>

              <div className="pt-6 border-t border-[#E8E1D9]">
                <h2 className="font-serif text-2xl font-semibold text-[#2A2421] mb-4">Questions?</h2>
                <p className="text-base mb-4">If you have any questions about these terms, we are happy to help.</p>
                <Link
                  to="/contact?inquiry=terms_of_service"
                  data-testid="terms-contact-link"
                  className="inline-flex items-center gap-1 text-sm font-medium text-[#A67A5B] hover:text-[#8C654A] transition-colors"
                >
                  Contact us here &rarr;
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
